import Navbar, {scrollToSection} from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Professionals from "../components/Professionals";
import Equipment from "../components/Equipment";
import Blog from "../components/Blog";
import LumiereArchive from "../components/LumiereArchive";
import AssetReturn from "../components/AssetReturn";
import Footer from "../components/Footer";
import ChatAssistant from "../components/ChatAssistant";
import * as React from "react";
import {useEffect} from "react";
import {useLocation} from "react-router-dom";

const Home: React.FC = () => {
    const {hash} = useLocation();

    // Arriving at "/#talent" (from the nav on another page, or a shared link)
    // should land on that section once the page has rendered.
    useEffect(() => {
        if (!hash) return;
        const id = window.requestAnimationFrame(() => scrollToSection(hash.slice(1)));
        return () => window.cancelAnimationFrame(id);
    }, [hash]);

    return (
        <div
            className="bg-lumina-dark min-h-screen text-white overflow-x-hidden selection:bg-lumina-accent selection:text-black">
            <Navbar/>
            <Hero/>
            <Services/>
            <Professionals/>
            <Equipment/>
            <LumiereArchive/>
            <Blog limit={6} />
            <AssetReturn/>
            <Footer/>
            <ChatAssistant/>
        </div>
    );
}

export default Home;
